import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1568d00f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["placeholder", "disabled", "autofocus"]

import { onMounted, ref, watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBox',
  props: {
    placeholder: {},
    value: {},
    disabled: { type: Boolean },
    autofocus: { type: Boolean }
  },
  emits: ["enter", "iconClicked"],
  setup(__props: any, { emit }) {

const props = __props;




const query = ref<string>();

watch(props, () => {
  if (props.value) query.value = props.value;
});

const checkInput = (e: KeyboardEvent) => {
  if (e.key === 'Enter') emit('enter', query.value ?? props.placeholder);
};

const inputQuery = ref<HTMLInputElement>();

onMounted(() => {
  if (props.autofocus) inputQuery.value?.focus();
});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("label", null, [
    _createVNode(_component_Icon, {
      icon: "prime:search",
      width: "20px",
      height: "20px",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('iconClicked', query.value ?? _ctx.placeholder)))
    }),
    _withDirectives(_createElementVNode("input", {
      type: "search",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((query).value = $event)),
      onKeydown: checkInput,
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      autofocus: _ctx.autofocus,
      ref_key: "inputQuery",
      ref: inputQuery
    }, null, 40, _hoisted_1), [
      [_vModelText, query.value]
    ])
  ]))
}
}

})